import React from 'react';

import Icon from '../Icon/Icon';

const MailIcon = ({isSingleColor, ...restProps}) => {
    return (
        <Icon width='64' height='64' fill='none' {...restProps}>
            <path
                d='M8 20C8 17.7909 9.79086 16 12 16H51.5897C53.7989 16 55.5897 17.7909 55.5897 20V44C55.5897 46.2091 53.7989 48 51.5897 48H12C9.79086 48 8 46.2091 8 44V20Z'
                fill='#393E44'
            />
            <path
                d='M30.4878 31.4703C31.4505 32.1884 32.7716 32.1886 33.7349 31.4713L53.6958 16.5992C53.8863 16.7174 54.0655 16.852 54.2329 16.9996L54.5962 17.4879L55.2231 18.3297C55.2516 18.3915 55.2798 18.4536 55.3052 18.5172L35.228 33.4761C33.3782 34.8539 30.8426 34.8532 28.9937 33.4742L8.45264 18.15C8.85269 17.3845 9.49312 16.7642 10.2739 16.3902L30.4878 31.4703Z'
                fill='#FFFDFB'
            />
            <path
                d='M52.687 42.8081C53.2132 43.396 53.1636 44.2995 52.5757 44.8257C51.9878 45.3517 51.0842 45.3012 50.5581 44.7134L38.5103 31.2524L40.8101 29.5396L52.687 42.8081Z'
                fill='#00D1D2'
            />
            <path
                d='M25.369 30.9911L13.0282 44.7157C12.5007 45.3023 11.5973 45.3504 11.0106 44.8231C10.424 44.2956 10.3758 43.3922 10.9032 42.8055L23.0702 29.2762L25.369 30.9911Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default MailIcon;
